<template>
  <div class="user-profile-dropdown">
    <!-- User Avatar/Name Button -->
    <button
      @click="toggleDropdown"
      class="user-profile-button"
      :class="{ active: isDropdownOpen }"
    >
      <div class="user-avatar">
        {{ userInitials }}
      </div>
      <div class="user-name">
        {{ userName }}
      </div>
      <svg
        class="dropdown-arrow"
        :class="{ rotated: isDropdownOpen }"
        width="12"
        height="12"
        viewBox="0 0 12 12"
        fill="none"
      >
        <path
          d="M2 4L6 8L10 4"
          stroke="currentColor"
          stroke-width="2"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
      </svg>
    </button>

    <!-- Dropdown Menu -->
    <div v-if="isDropdownOpen" class="dropdown-menu">
      <div class="dropdown-header">
        <div class="dropdown-user-info">
          <div class="dropdown-avatar">{{ userInitials }}</div>
          <div class="dropdown-user-details">
            <div class="dropdown-user-name">{{ userName }}</div>
            <div class="dropdown-user-email">{{ userEmail }}</div>
          </div>
        </div>
      </div>

      <!-- <div class="dropdown-options">
        <button @click="handleProfile" class="dropdown-option">
          <svg width="16" height="16" viewBox="0 0 16 16" fill="none">
            <path
              d="M8 8C10.21 8 12 6.21 12 4C12 1.79 10.21 0 8 0C5.79 0 4 1.79 4 4C4 6.21 5.79 8 8 8ZM8 10C5.33 10 0 11.34 0 14V16H16V14C16 11.34 10.67 10 8 10Z"
              fill="currentColor"
            />
          </svg>
          My Profile
        </button>

        <button @click="handleSettings" class="dropdown-option">
          <svg width="16" height="16" viewBox="0 0 16 16" fill="none">
            <path
              d="M8 4.754a3.246 3.246 0 1 0 0 6.492 3.246 3.246 0 0 0 0-6.492zM5.754 8a2.246 2.246 0 1 1 4.492 0 2.246 2.246 0 0 1-4.492 0z"
              fill="currentColor"
            />
            <path
              d="M9.796 1.343c-.527-1.79-3.065-1.79-3.592 0l-.094.319a.873.873 0 0 1-1.255.52l-.292-.16c-1.64-.892-3.433.902-2.54 2.541l.159.292a.873.873 0 0 1-.52 1.255l-.319.094c-1.79.527-1.79 3.065 0 3.592l.319.094a.873.873 0 0 1 .52 1.255l-.16.292c-.892 1.64.901 3.434 2.541 2.54l.292-.159a.873.873 0 0 1 1.255.52l.094.319c.527 1.79 3.065 1.79 3.592 0l.094-.319a.873.873 0 0 1 1.255-.52l.292.16c1.64.893 3.434-.902 2.54-2.541l-.159-.292a.873.873 0 0 1 .52-1.255l.319-.094c1.79-.527 1.79-3.065 0-3.592l-.319-.094a.873.873 0 0 1-.52-1.255l.16-.292c.893-1.64-.902-3.433-2.541-2.54l-.292.159a.873.873 0 0 1-1.255-.52l-.094-.319zm-2.633.283c.246-.835 1.428-.835 1.674 0l.094.319a1.873 1.873 0 0 0 2.693 1.115l.291-.16c.764-.415 1.6.42 1.184 1.185l-.159.292a1.873 1.873 0 0 0 1.116 2.692l.318.094c.835.246.835 1.428 0 1.674l-.319.094a1.873 1.873 0 0 0-1.115 2.693l.16.291c.415.764-.42 1.6-1.185 1.184l-.291-.159a1.873 1.873 0 0 0-2.693 1.116l-.094.318c-.246.835-1.428.835-1.674 0l-.094-.319a1.873 1.873 0 0 0-2.692-1.115l-.292.16c-.764.415-1.6-.42-1.184-1.185l.159-.291A1.873 1.873 0 0 0 1.945 8.93l-.319-.094c-.835-.246-.835-1.428 0-1.674l.319-.094A1.873 1.873 0 0 0 3.06 4.377l-.16-.292c-.415-.764.42-1.6 1.185-1.184l.292.159a1.873 1.873 0 0 0 2.692-1.115l.094-.319z"
              fill="currentColor"
            />
          </svg>
          Settings
        </button>

        <button @click="handleHelp" class="dropdown-option">
          <svg width="16" height="16" viewBox="0 0 16 16" fill="none">
            <path
              d="M8 15A7 7 0 1 1 8 1a7 7 0 0 1 0 14zm0 1A8 8 0 1 0 8 0a8 8 0 0 0 0 16z"
              fill="currentColor"
            />
            <path
              d="M5.255 5.786a.237.237 0 0 0 .241.247h.825c.138 0 .248-.113.266-.25.09-.656.54-1.134 1.342-1.134.686 0 1.314.343 1.314 1.168 0 .635-.374.927-.965 1.371-.673.489-1.206 1.06-1.206 2.016v.75a.25.25 0 0 0 .25.25h.811a.25.25 0 0 0 .25-.25v-.563c0-.653.421-1.004 1.089-1.473.667-.47 1.411-1.001 1.411-2.25 0-1.25-1.028-2.25-2.5-2.25-1.5 0-2.5 1.25-2.5 2.25 0 .25.25.5.5.5h.5a.5.5 0 0 0 .5-.5zM6.5 12a.5.5 0 1 1-1 0 .5.5 0 0 1 1 0z"
              fill="currentColor"
            />
          </svg>
          Help
        </button>
      </div> -->

      <router-link to="/survey-info" class="dropdown-option dropdown-link">
        <i class="fas fa-info-circle"></i> Survey Info
      </router-link>
      <button @click="handleSignOut" class="dropdown-option sign-out-option">
        <svg width="16" height="16" viewBox="0 0 16 16" fill="none">
          <path
            d="M7.207 1.414a1 1 0 0 1 1.414 0L13.5 6.793a1 1 0 0 1 0 1.414L8.621 13.086a1 1 0 0 1-1.414-1.414L11.086 8.5 7.207 4.621a1 1 0 0 1 0-1.207z"
            fill="currentColor"
          />
          <path
            d="M1.5 8a.5.5 0 0 1 .5-.5h8a.5.5 0 0 1 0 1H2a.5.5 0 0 1-.5-.5z"
            fill="currentColor"
          />
        </svg>
        Sign Out
      </button>
    </div>

    <!-- Backdrop to close dropdown when clicking outside -->
    <div
      v-if="isDropdownOpen"
      @click="closeDropdown"
      class="dropdown-backdrop"
    ></div>
  </div>
</template>

<script setup>
import { ref, computed, onMounted, onUnmounted } from "vue";

const props = defineProps({
  userName: {
    // Note: allow null/undefined gracefully (tests cover this case and the
    // computed `userInitials` already handles it).
    required: false,
    default: "",
  },
  userEmail: {
    type: String,
    required: true,
  },
});

const emit = defineEmits(["signOut", "profile", "settings", "help"]);

const isDropdownOpen = ref(false);

// Compute user initials from name
const userInitials = computed(() => {
  if (
    !props.userName ||
    typeof props.userName !== "string" ||
    props.userName.trim() === ""
  ) {
    return "?";
  }

  const trimmedName = props.userName.trim();
  const names = trimmedName.split(" ").filter((name) => name.length > 0);

  if (names.length >= 2) {
    const firstInitial = names[0][0] || "";
    const lastInitial = names[names.length - 1][0] || "";
    return (firstInitial + lastInitial).toUpperCase();
  }

  if (names.length === 1 && names[0].length > 0) {
    return names[0][0].toUpperCase();
  }

  return "?";
});

const toggleDropdown = () => {
  isDropdownOpen.value = !isDropdownOpen.value;
};

const closeDropdown = () => {
  isDropdownOpen.value = false;
};

const handleSignOut = () => {
  closeDropdown();
  emit("signOut");
};

const handleProfile = () => {
  closeDropdown();
  emit("profile");
};

const handleSettings = () => {
  closeDropdown();
  emit("settings");
};

const handleHelp = () => {
  closeDropdown();
  emit("help");
};

// Close dropdown when pressing Escape key
const handleKeydown = (event) => {
  if (event.key === "Escape" && isDropdownOpen.value) {
    closeDropdown();
  }
};

onMounted(() => {
  document.addEventListener("keydown", handleKeydown);
});

onUnmounted(() => {
  document.removeEventListener("keydown", handleKeydown);
});
</script>

<style scoped>
.user-profile-dropdown {
  position: relative;
  display: inline-block;
}

.user-profile-button {
  display: flex;
  align-items: center;
  gap: 0.5rem;
  padding: 0.5rem 0.75rem;
  background: white;
  border: 1px solid #e1e5e9;
  border-radius: 8px;
  cursor: pointer;
  transition: all 0.2s ease;
  font-size: 0.9rem;
  color: var(--text-color);
}

.user-profile-button:hover {
  background: #f8f9fa;
  border-color: #42b883;
}

.user-profile-button.active {
  background: #f8f9fa;
  border-color: #42b883;
  box-shadow: 0 0 0 2px rgba(66, 184, 131, 0.2);
}

.user-avatar {
  width: 32px;
  height: 32px;
  border-radius: 50%;
  background: var(--primary-color);
  color: white;
  display: flex;
  align-items: center;
  justify-content: center;
  font-weight: 600;
  font-size: 0.8rem;
  flex-shrink: 0;
}

.user-name {
  font-weight: 500;
  color: var(--text-color);
}

.dropdown-arrow {
  transition: transform 0.2s ease;
  color: #6c757d;
}

.dropdown-arrow.rotated {
  transform: rotate(180deg);
}

.dropdown-menu {
  position: absolute;
  top: calc(100% + 0.5rem);
  right: 0;
  min-width: 240px;
  background: white;
  border: 1px solid #e1e5e9;
  border-radius: 8px;
  box-shadow: 0 4px 20px rgba(0, 0, 0, 0.15);
  z-index: 1000;
  animation: dropdownFadeIn 0.2s ease;
}

@keyframes dropdownFadeIn {
  from {
    opacity: 0;
    transform: translateY(-10px);
  }
  to {
    opacity: 1;
    transform: translateY(0);
  }
}

.dropdown-header {
  padding: 1rem;
  border-bottom: 1px solid #f1f3f4;
}

.dropdown-user-info {
  display: flex;
  align-items: center;
  gap: 0.75rem;
}

.dropdown-avatar {
  width: 40px;
  height: 40px;
  border-radius: 50%;
  background: var(--primary-color);
  color: white;
  display: flex;
  align-items: center;
  justify-content: center;
  font-weight: 600;
  font-size: 0.9rem;
  flex-shrink: 0;
}

.dropdown-user-details {
  flex: 1;
  min-width: 0;
}

.dropdown-user-name {
  font-weight: 600;
  color: var(--text-color);
  font-size: 0.95rem;
  margin-bottom: 0.25rem;
}

.dropdown-user-email {
  color: #6c757d;
  font-size: 0.85rem;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.dropdown-divider {
  height: 1px;
  background: #f1f3f4;
  margin: 0.5rem 0;
}

.dropdown-options {
  padding: 0.5rem 0;
}

.dropdown-option {
  display: flex;
  align-items: center;
  gap: 0.75rem;
  width: 100%;
  padding: 0.75rem 1rem;
  background: none;
  border: none;
  cursor: pointer;
  color: var(--text-color);
  font-size: 0.9rem;
  transition: background-color 0.2s ease;
  text-align: left;
}

.dropdown-option:hover {
  background: #f8f9fa;
}

.dropdown-option svg {
  color: #6c757d;
  flex-shrink: 0;
}

.sign-out-option {
  color: #dc3545;
}

.sign-out-option:hover {
  background: #fff5f5;
}

.sign-out-option svg {
  color: #dc3545;
}

.dropdown-backdrop {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  z-index: 999;
}

.dropdown-link {
  color: #005461;
  text-decoration: none;
  font-weight: 500;
  display: flex;
  align-items: center;
  gap: 0.5rem;
  transition: color 0.2s;
}
.dropdown-link:hover {
  color: #003d49;
}

/* Mobile responsive */
@media (max-width: 768px) {
  .user-name {
    display: none;
  }

  .dropdown-menu {
    right: -0.5rem;
    min-width: 200px;
  }

  .dropdown-user-name {
    font-size: 0.9rem;
  }

  .dropdown-user-email {
    font-size: 0.8rem;
  }
}
</style>
